/*jshint esversion: 11 */

class DragScroll {
    constructor(container, options = {}) {
        this.el = container;
        this.threshold = options.threshold ?? 6; // px before we treat as drag
        this.isDragging = false;
        this.dragMoved = false;
        this.pointerId = undefined;
        this.startX = 0;
        this.startScrollLeft = 0;
        this.suppressClick = false;

        this.init();
    }

    init() {
        // Prevent the native image drag ghost
        this.el.querySelectorAll('img').forEach(img => {
            img.addEventListener('dragstart', e => e.preventDefault());
        });

        // Pointer events
        this.el.addEventListener('pointerdown', this.onDown.bind(this));
        this.el.addEventListener('pointermove', this.onMove.bind(this), { passive: false });
        this.el.addEventListener('pointerup', this.onUp.bind(this));
        this.el.addEventListener('pointercancel', this.onCancel.bind(this));

        // Suppress click immediately following a drag
        this.el.addEventListener('click', (e) => {
            if (this.suppressClick) {
                e.preventDefault();
                e.stopImmediatePropagation();
                this.suppressClick = false;
            }
        }, true);
    }

    onDown(e) {
        this.pointerId = e.pointerId;
        this.startX = e.clientX;
        this.startScrollLeft = this.el.scrollLeft;
        this.dragMoved = false;
        this.isDragging = false;
    }

    onMove(e) {
        if (this.pointerId == null || e.pointerId !== this.pointerId) return;

        const diff = e.clientX - this.startX;

        // Start drag only after threshold
        if (!this.isDragging && Math.abs(diff) > this.threshold) {
            this.isDragging = true;
            this.dragMoved = true;
            this.el.classList.add('dragging');

            try { this.el.setPointerCapture(this.pointerId); } catch { }

            this.suppressClick = true;
        }

        if (this.isDragging) {
            e.preventDefault();
            this.el.scrollLeft = this.startScrollLeft - diff;
        }
    }

    onUp(e) {
        if (this.pointerId == null || (e && e.pointerId !== undefined && e.pointerId !== this.pointerId)) {
            this.cleanupPointer();
            return;
        }

        if (this.isDragging) {
            this.el.classList.remove('dragging');
            try { this.el.releasePointerCapture(this.pointerId); } catch { }
        }

        this.cleanupPointer();
    }

    onCancel(e) {
        if (this.pointerId != null) {
            try { this.el.releasePointerCapture(this.pointerId); } catch { }
        }
        this.cleanupPointer();
    }

    cleanupPointer() {
        this.isDragging = false;
        this.pointerId = undefined;
        this.startX = 0;
        this.startScrollLeft = 0;
    }
}

// Auto-init on DOM ready
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.scroll-drag').forEach(el => new DragScroll(el));
});
